export const OperationsJournal = {
  en: {
    From: 'From (inclusive)',
    Till: 'Till (inclusive)',
    'Operations Journal': 'Operations Journal',
    Operation: 'Operation',
    Location: 'Location',
    'Location kind': 'Location kind',
    location_kind_physical: 'Physical',
    location_kind_online: 'Online',
    location_kind_head_office: 'Head Office',
    Direction: 'Direction',
    'Legal Entity': 'Legal Entity',
    'Line kind': 'Line kind',
    Category: 'Category',
    'Client deposit': 'Client deposit',
    'Internal transfer': 'Internal transfer',
    Discount: 'Discount',
    'Service liability': 'Service liability',
    'Card liability': 'Card liability',
    'Certificate liability': 'Certificate liability',
    Service: 'Service',
    Card: 'Card',
    Certificate: 'Certificate',
    Goods: 'Goods',
    'Cash Register': 'Cash Register',
    Recognized: 'Recognized',
    Source: 'Source',
    'Created Via': 'Created Via',
    'Created By': 'Created By',
    Reversed: 'Reversed',
    'Hide reversed': 'Hide reversed',
    Reverse: 'Reverse',
    'Reverse Operation': 'Reverse Operation',
    'Reverse operation confirmation':
      'Are you sure you want to reverse operation',
    'Fiscal register hint':
      'The operation went through a register that works with fiscalization — a service receipt will be created in Checkbox.',
    Sale: 'Sale',
    Refund: 'Refund',
    Payment: 'Payment',
    'Cash transfer': 'Cash transfer',
    Reversal: 'Reversal',
    'Card sale': 'Card sale',
    'Card use': 'Card use',
    'Card use revert': 'Card use revert',
    'Card refund': 'Card refund',
    'Card expiry breakage': 'Card expiry breakage',
    'Time card recognition': 'Time card recognition',
    'Card freeze': 'Card freeze',
    'Card unfreeze': 'Card unfreeze',
    'Certificate sale': 'Certificate sale',
    'Certificate activation': 'Certificate activation',
    'Certificate refund': 'Certificate refund',
    'Certificate expiry breakage': 'Certificate expiry breakage',
    'Deposit top-up': 'Deposit top-up',
    'Deposit use': 'Deposit use',
    'Deposit refund': 'Deposit refund',
    'Inventory receipt': 'Inventory receipt',
    'Inventory write-off': 'Inventory write-off',
    'Inventory count': 'Inventory count',
    'Inventory promo': 'Inventory promo',
    'Salary accrual': 'Salary accrual',
    'Salary payout': 'Salary payout',
    'Cash shortage': 'Cash shortage',
    'Cash surplus': 'Cash surplus',
    'Service use': 'Service use',
    'Service use revert': 'Service use revert',
    'Service refund': 'Service refund',
    'Service breakage': 'Service breakage',
    Admin: 'Admin',
    System: 'System',
    Import: 'Import',
  },
  uk: {
    From: 'З (включно)',
    Till: 'До (включно)',
    'Operations Journal': 'Журнал операцій',
    Operation: 'Операція',
    Location: 'Локація',
    'Location kind': 'Тип локації',
    location_kind_physical: 'Фізична',
    location_kind_online: 'Онлайн',
    location_kind_head_office: 'Головний офіс',
    Direction: 'Напрямок',
    'Legal Entity': 'Юридична особа',
    'Line kind': 'Тип рядка',
    Category: 'Категорія',
    'Client deposit': 'Депозит клієнта',
    'Internal transfer': 'Внутрішнє переміщення',
    Discount: 'Знижка',
    'Service liability': 'Зобов’язання за послугою',
    'Card liability': 'Зобов’язання за карткою',
    'Certificate liability': 'Зобов’язання за сертифікатом',
    Service: 'Послуга',
    Card: 'Картка',
    Certificate: 'Сертифікат',
    Goods: 'Товари',
    'Cash Register': 'Каса',
    Recognized: 'Визнано',
    Source: 'Джерело',
    'Created Via': 'Спосіб створення',
    'Created By': 'Ким створено',
    Reversed: 'Сторновано',
    'Hide reversed': 'Сховати сторновані',
    Reverse: 'Сторнувати',
    'Reverse Operation': 'Сторнувати операцію',
    'Reverse operation confirmation':
      'Ви впевнені, що хочете сторнувати операцію',
    'Fiscal register hint':
      'Операція пройшла через касу, що працює з фіскалізацією — у Checkbox буде створено службовий чек.',
    Sale: 'Продаж',
    Refund: 'Повернення',
    Payment: 'Платіж',
    'Cash transfer': 'Переказ між касами',
    Reversal: 'Сторнування',
    'Card sale': 'Продаж картки',
    'Card use': 'Використання картки',
    'Card use revert': 'Скасування використання картки',
    'Card refund': 'Повернення картки',
    'Card expiry breakage': 'Згорання картки',
    'Time card recognition': 'Визнання тайм-картки',
    'Card freeze': 'Заморозка картки',
    'Card unfreeze': 'Розморозка картки',
    'Certificate sale': 'Продаж сертифіката',
    'Certificate activation': 'Активація сертифіката',
    'Certificate refund': 'Повернення сертифіката',
    'Certificate expiry breakage': 'Згорання сертифіката',
    'Deposit top-up': 'Поповнення депозиту',
    'Deposit use': 'Використання депозиту',
    'Deposit refund': 'Повернення депозиту',
    'Inventory receipt': 'Оприбуткування товару',
    'Inventory write-off': 'Списання товару',
    'Inventory count': 'Інвентаризація',
    'Inventory promo': 'Промо-видача товару',
    'Salary accrual': 'Нарахування зарплати',
    'Salary payout': 'Виплата зарплати',
    'Cash shortage': 'Нестача в касі',
    'Cash surplus': 'Надлишок у касі',
    'Service use': 'Використання послуги',
    'Service use revert': 'Скасування використання послуги',
    'Service refund': 'Повернення послуги',
    'Service breakage': 'Згорання послуги',
    Admin: 'Адміністратор',
    System: 'Система',
    Import: 'Імпорт',
  },
};
